(function ( $ ) {
    $.fn.showOnScroll = function() {
        var items = [];

        console.log('here')

        $(this).each(function(i) {
            var $that = $(this),
                offset = $that.height()*$that.data('offset') || 75,
                offset = $that.data('pixel-offset') || offset,
                top = $that.offset().top + offset,
                toShow = wb > top ? true : false;

            $that.removeClass('not-init');

            if (toShow) {
                $that.addClass('shown');
            } else {
                items.push({
                    trigger: $that,
                    top : top
                });
            };

            $window.resize(function(){
                offset = $that.height()*$that.data('offset') || 75;
                offset = $that.data('pixel-offset') || offset;
                top = $that.offset().top + offset;
                toShow = wb > top ? true : false;

                $that.removeClass('not-init');

                if (toShow) {
                    $that.addClass('shown');
                } else {
                    items[i] = {
                        trigger: $that,
                        top : top
                    };
                };
            })
        });

        return $(window).scroll(function(e) {
            e.preventDefault();
            items.map(function(elem, i){
                if (elem.top <= wb) {
                    elem.trigger.addClass('shown');
                };
            });
        });
    };
}( jQuery ));

function initToShow() {
    console.log('here')
    if ($('.js-to-show.not-init').length) {
        $('.js-to-show.not-init').showOnScroll();
    }
}